export type SortDirection = 'asc' | 'desc' | '';

export type ConsumerBusinessIndicator = 'C' | 'B';

export type AuthNContext = 'MFA_BYPASSED' | 'MFA_ACTION_PENDING' | 'MFA_PENDING_SETUP' | 'MFA_UNKNOWN' | 'MFA_SETUP_ERROR';

/**
 * The product indicator type as it comes from the API
 */
export type ProductIndicatorApi = 'NONE' | 'CONSUMER' | 'BUSINESS' | 'BOTH';

/*
 * When modifying this union type keep in mind:
 *  - consumer-services.component.html: section that determines which subject form component to load
 *  - consumer-services.component.ts: section that determines how the request is formed
 *  - constants.ts: object which links product codes to each type
 */
export type IfsProductType = 'aml' | 'ebvsid' | 'eAml' | 'avs' | 'bvs' | 'dirs' | 'eDirs' | 'dirsLookup' | 'hawk';

export type ProductType = 'consumer' | 'MDS' | IfsProductType;
export type IfsProductCodesTypeMap = { [key in IfsProductType]: string[] };
export type IfsProductTypeMap = { [key in IfsProductType]: string };

export type FormControls = {[key: string]: any};

export enum PingErrorId {
  ok                 = 200,
  maxDevices         = 20562,
  userDoesntExist    = 10564,
  enterCodeFromEmail = 30005,
  enterCodeFromApp   = 30007,
  sessionNotValid    = 20517,
  incorrectPassword  = 20513,
  incorrectCode      = 20532,
  deviceAlreadyInUse = 20571,
  invalidPhone       = 20559
}

export type PingError = 'ok' | 'User does not exist.' | 'user.exceeded.num.of.devices';
export type PingDeviceType = 'Email' | 'SMS' | 'Voice' | 'Android' | 'iPhone'; //When adding to this, expand MfaService#getTypeIcon() accordingly
export type PingPairingMethod = 'EMAIL' | 'SMS' | 'VOICE';
export type PingDeviceRole = 'PRIMARY' | 'SECONDARY';
export type PingPairingStatus = 'PAIRED' | 'NOT_CLAIMED';
